/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Delete_Folder_EmptyInputs */

const en_dialog_delete_folder_empty = /** @type {(inputs: Dialog_Delete_Folder_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This folder is empty and will be permanently deleted.`)
};

const es_dialog_delete_folder_empty = /** @type {(inputs: Dialog_Delete_Folder_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta carpeta está vacía y se eliminará permanentemente.`)
};

/**
* | output |
* | --- |
* | "This folder is empty and will be permanently deleted." |
*
* @param {Dialog_Delete_Folder_EmptyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_delete_folder_empty = /** @type {((inputs?: Dialog_Delete_Folder_EmptyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Delete_Folder_EmptyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_delete_folder_empty(inputs)
	return en_dialog_delete_folder_empty(inputs)
});